module.exports = __webpack_public_path__ + "static/media/navbar_logo1.93c33871.jpg";